import React from 'react';
import ReactDOM from 'react-dom/client';
import 'swiper/css';

import App from './App';
import './GlobalStyle';
import { initSentry } from './Sentry';
import { setLangugeAndFont } from './SetLanguageAndFont';
import './i18n';

initSentry();
setLangugeAndFont();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
